import React from 'react';
import PropTypes from 'prop-types';
import { ContactMe, DataContactMe, Made } from './styles';
import Image from '../../UI/Image';

const ContactMeLayout = ({ social, socialIcons }) => (
  <footer id='contact-me' style={{ color: '#FFF' }}>
    <ContactMe>
      <Image
        src='/images/logo-name.png'
        alt='logo-with-name'
        style={{
          width: '50%',
          maxWidth: '300px'
        }}
      />
      <DataContactMe>
        <div className='number-email'>
          <span className='number'>{social.phoneNumber}:</span>
          <a href='tel:+00 012-3456-789'>+00 012-3456-789</a>
          <span className='email'>{social.email}:</span>
          <a href='mailto:j4asdev@gmail.com'>j4asdev@gmail.com</a>
        </div>
        <div className='icons-socials'>
          { socialIcons.map(item =>
            <a key={item.id} href={item.link}>
              <i className={`fab ${item.isClass}`}/>
            </a>
          )}
        </div>
      </DataContactMe>
    </ContactMe>
    <Made>
      <div>
        <p>{social.madeWith}</p>
        <i className='fas fa-heart' />
        <p>{social.and}</p>
        <i className='fas fa-mug-hot' />
      </div>
      <p>&copy; Jonathan Araujo - 2019</p>
    </Made>
  </footer>
);

ContactMeLayout.propTypes = {
  contactData: PropTypes.array,
  socialIcons: PropTypes.array,
  social: PropTypes.object
};

export default ContactMeLayout;
